import Session from './session';
const params = window.location.href.split("?")[1]

if(params){
  const items = params.split("&")
  if(items && items.length > 0){
    items.forEach(item => {
      const param = item.split("=")
      Session.add(param[0], param[1])
    })
  }
}